// extracted by mini-css-extract-plugin
export default {"container":"update_price_container__9ZkZc","inp":"update_price_inp__lUNsr","button":"update_price_button__lmwS+"};